import TrakingListing from './TrakingListing'

export default TrakingListing
